<template>
    <main class="dashboard">
        <div class="main-section" style="min-height: 100vh; background: rgb(248, 249, 253);">
            <div class="container">
                <div class="has-background-white tipo_negocio pt-3">
                    <div class="">
                        <p class="title_type">
                            Plan de Cuentas
                        </p>
                        <p class="subtitle_type">
                            Cuentas {{ tipo_negocio_consolidado }}
                        </p>
                        <table class="central_table">
                            <tr>
                                <td colspan="2"></td>
                                <td colspan="2" class="levels">
                                    <SimpleButton class="usar_todos" @click="usar_todos()">
                                        Usar todos
                                    </SimpleButton>
                                </td>
                            </tr>
                            <tr v-for="row in account_plans" :key="row.id" class="super_type">
                                <td :class="[row.level_1, 'levels']">
                                    {{ row.level_1 }}
                                </td>
                                <td :class="[row.level_1, 'levels']">
                                    {{ row.level_2 }}
                                </td>
                                <td class="levels">
                                    <input type="checkbox" :id="'ap_' + row.id" v-model="checked['ap_' + row.id]" />
                                </td>
                                <td>
                                    <div class="type_name" @click="toggle('ap_' + row.id)">
                                        {{ row.level_3 }}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b-select size="is-small" class="new_elem_row" id="level_1_select"
                                        v-model="new_level_1_value" placeholder="Nivel 1" rules="required"
                                        v-on:input="level_1_change">
                                        <option v-for="value in level_1_values" :key="value.name" :value="value.name">
                                            {{ value.name }}
                                        </option>
                                    </b-select>
                                </td>
                                <td class="">
                                    <b-select size="is-small" expanded class="new_elem_row default_empty td_level_2"
                                        id="level_2_select" v-model="new_level_2_value" placeholder="Nivel 2"
                                        rules="required">
                                        <option v-for="value in level_2_values_depending" :key="value.id"
                                            :value="value.id">
                                            {{ value.level_2 }}
                                        </option>
                                    </b-select>
                                </td>
                                <td colspan="2">
                                    <b-input size="is-small" class="new_cuenta new_elem_row" placeholder="Cuenta"
                                        v-model="new_cuenta" />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2"></td>
                                <td colspan="2">
                                    <SimpleButton class="agregar_cuenta" @click="agregar_cuenta()">
                                        Agregar cuenta
                                    </SimpleButton>
                                </td>
                            </tr>
                        </table>
                        <div class="button_div">
                            <b-button class="button" @click="load_default_plans()">
                                Volver atras
                            </b-button>
                            <b-button class="grabar" type="is-secondary" @click="grabar_planes_de_cuenta()">
                                Grabar
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { createAccount, getAccountPlanForCompany, saveAccountPlans } from "@/api/carteraAnalista";
import SimpleButton from "@/components/modals/SimpleButton";
import { consoleHandlerError, notificate } from "@/utils/message";

export default {
    name: "CompanyInfoAccountPlan",
    props: {
        basicData: {
            type: Object,
            required: true,
            default: () => ({})
        },
    },
    components: {
        SimpleButton,
    },
    created() {
    },
    mounted() {
        if (this.basic_data) {
            this.load_default_plans();
        }
    },
    data() {
        return {
            tipo_negocio_consolidado: '$%',
            basic_data: {},
            super_types: [],
            checked: {},
            already_saved: {},
            account_plans: [],
            new_level_1_value: '',
            new_level_2_value: '',
            level_1_values: [],
            level_2_values: {},
            level_2_values_depending: [],
            new_cuenta: '',
        };
    },
    computed: {
    },
    methods: {
        level_1_change(val) {
            this.level_2_values_depending = this.level_2_values[val]['items'];
        },
        async agregar_cuenta() {
            if (!this.basic_data.companyId || !this.new_level_2_value || !this.new_cuenta) {
                notificate('Debe llenar los datos.');
                return;
            }
            try {
                const response = createAccount(this.basic_data.companyId, this.new_level_2_value, this.new_cuenta);
                const resp = await response;
                if (resp.data['status'] == 'Ok') {
                    notificate('Cuenta grabada exitosamente.');
                } else {
                    notificate(resp.data['status']);
                }
                this.load_default_plans();
            } catch (error) {
                consoleHandlerError({ error, empty: true });
            }

        },
        async grabar_planes_de_cuenta() {
            const response = saveAccountPlans(this.basic_data.companyId, this.checked, this.already_saved);
            const resp = await response;
            this.load_default_plans();
            if (resp.data['status'] == 'Ok') {
                notificate('Plan de Cuentas grabado exitosamente.');
            } else {
                notificate(resp.data['status']);
            }
        },
        toggle(key) {
            const newChecked = { ...this.checked };
            newChecked[key] = !newChecked[key];
            this.checked = newChecked;
        },
        async load_default_plans() {
            if (this.basic_data && this.basic_data.companyId) {
                const response = await getAccountPlanForCompany(this.basic_data.companyId);
                this.level_1_values = response.data['level_1_values'];
                this.level_2_values = response.data['level_2_values'];
                this.account_plans = response.data['account_plans'];
                for (let i = 0; i < this.account_plans.length; i++) {
                    let isIn = false;
                    if (this.account_plans[i].saved) {
                        isIn = true;
                        this.already_saved['ap_' + this.account_plans[i].id] = this.account_plans[i].apc_id;
                    }
                    this.checked['ap_' + this.account_plans[i].id] = isIn;
                }
                this.tipo_negocio_consolidado = response.data['tipo_negocio_consolidado']
            }
        },
        usar_todos() {
            const newChecked = { ...this.checked }
            for (const key in this.checked) {
                newChecked[key] = true;
            }
            this.checked = newChecked;
        },
    },
    watch: {
        basicData(data) {
            this.basic_data = data;
            this.load_default_plans(this.basic_data.companyId);
        }
    }
};
</script>
<style scoped>
.container {
    width: 100%;
}

.super_style {
    font-weight: bold;
}

.super_type {
    text-align: left;
    /* Aligns the text to the left */
    margin-left: 10%;
    /* Adds some space to the left of each super_type row */
}

.type {
    text-align: left;
    /* Ensures the inner content is also left-aligned */
    margin-left: 40%;
    /*Indent for the type items */
}

.config_container {
    width: 400px;
    margin-left: 100px;
}

.full-width-div {
    width: 100%;
    margin: 0;
    padding: 0;
}

.central_table {
    width: 100%;
    margin-left: 10%;
}

.sub_table {
    margin-left: 20%;
}

.title_type {
    font-weight: bold;
    font-size: 1.2em;
    text-align: center;
    margin-bottom: 2%;
}

.subtitle_type {
    font-weight: bold;
    font-size: 1.15em;
    text-align: center;
    margin-bottom: 2%;
}

.button_div {
    text-align: right;
    margin-top: 2%;
    margin-right: 23%;
}

.type_name {
    margin-left: 0.5em;
}

.Ventas {
    background-color: #f9f9ff;
}

.Costos {
    background-color: #fff0f0;
}

.Gastos {
    background-color: #fff7f7;
}

.No {
    background-color: #f7f7f7;
}

.levels {
    padding-left: 10px;
}

.bold {
    font-weight: 600;
}

.usar_todos {
    font-weight: 600;
    padding: 2px 5px 2px 5px;
    border: 1px solid #44444477;
    background: linear-gradient(45deg, #fafdff, #fafdff);
}

.agregar_cuenta {
    font-weight: 600;
    margin: 10px 0 5px 10px;
    border: 1px solid #44444477;
    background: linear-gradient(45deg, #fafdff, #fafdff);
}

.grabar {
    margin-left: 10px;
}

.l1 {
    display: block;
    width: 100px;
}

.l2 {
    display: block;
    width: 100px;
}

.new_elem_row {
    margin-left: 10px;
    margin-top: 5px;
}

.new_cuenta {
    width: 200px;
}

#level_2_select {
    min-width: 100px;
}

.new_elem_row span select {
    font-weight: bold;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.td_level_2 {
    width: 14em;
}
</style>